<template>
    <div class="search-box" v-loading="loadingFlag">
        <el-select v-model="currViewName" @change="changeView" class="m-2" :placeholder="i18n.tkey('lang_search_text')" size="large" style="width: 5em;">
            <el-option
                    v-for="n in viewList"
                    :key="n.key"
                    :label="n.key"
                    :value="n.value"
            />
        </el-select>
        <el-input
                v-model="keyword"
                class="search-input"
                size="large"
                :placeholder="searchHolder"
                :prefix-icon="Search"
                clearable
                @change="changeKeyword"
        />
    </div>

    <div class="type-toggle-box">
        <div>
            <ProductTypeTreeSelect
                v-model="selectedType"
                v-show="currViewName === 'material'"
                v-loading="loadingFlag"
                @changeSelect="changeProductType"
            />
            <span>&nbsp;</span>
        </div>

        <ListDisplayToggle
            :type="viewType"
            v-show="currViewName !== 'card'"
            @clickBtn="changeViewType"
        />

        <div
            v-loading="loadingFlag"
            v-show="currViewName === 'card'"
        >
            <el-button
                type="primary"
                @click="clickPrint"
            >
                {{i18n.tkey("lang_download_doc")}}
            </el-button>
        </div>
    </div>

    <div class="search-result" v-infinite-scroll="scrollLoadFunc">
        <el-row :gutter="10">
            <el-col
                :span="cols"
                v-for="(value, index) in materialList"
                :key="value.id"
                class="record-box"
            >
                <SearchMaterialResult
                    :obj="value"
                    :title="value.companyname"
                    :titleDes="`${value.raddinfo1}-${value.raddinfo2}`"
                    :imgUrl="myUtil.generateProductImg(value)"
                    :name="value.productname"
                    :description="value.description"
                    :cost="value.cost"
                    :btn-label="i18n.tkey('lang_go_booth')"
                    :tag="viewType"
                    @click-go-shop="goShop"
                />
            </el-col>
        </el-row>

        <el-row :gutter="10">
            <el-col
                :span="cols"
                v-for="(value, index) in companyList"
                :key="value.id"
                class="record-box"
            >
                <shopHallResultComponent :obj="value" @click-go-shop="goShop" />
            </el-col>
        </el-row>

        <el-row
            :gutter="10"
            v-loading="loadingFlag"
        >
            <el-col
                :span="cols"
                v-for="(value, index) in cardList"
                :key="value.id"
                class="record-box"
            >
                <SearchHallCardResultComponent :card="value" />
            </el-col>
        </el-row>

        <el-empty
            :description="i18n.tkey('lang_temporary_no_data')"
            v-show="materialList.length == 0 && companyList.length == 0 && currViewName !== 'card'"
        />

        <el-empty
            :description="i18n.tkey('lang_temporary_no_data')"
            v-show="cardList.length == 0 && currViewName === 'card'"
        />

        <div v-show="false">
            <PaginationComponent
                :pageObj="pageObj"
                @goPage="changePage"
                style="border-top: 0"
            />
        </div>
    </div>

    <div
        class="printer-dom"
        v-if="null != printHallId"
    >
        <ExhibitorPrinter
            :hallId="printHallId"
            @print-complete="printCallback"
        />
    </div>
</template>

<script setup>
    import {getCurrentInstance, ref, onMounted, toRef, inject, onBeforeMount} from 'vue'
    import {Search} from '@element-plus/icons-vue';
    import shopHallResultComponent from '@/components/phone/hall/shopHallResultComponent.vue'
    import record15Api from "@/request/record15Api";
    import {useUserinfo} from "@/stores/userinfo";
    import materialApi from "@/request/materialApi";
    import PaginationComponent from "@/components/shopopee/common/paginationComponent.vue";
    import myUtil from "@/util/util";
    import SearchMaterialResult from "@/components/shopopee/dataDisplay/searchMaterialResult.vue";
    import ListDisplayToggle from "@/components/shopopee/common/listDisplayToggle.vue";
    import ProductTypeTreeSelect from "@/components/shopopee/whatsShopsBCata/productTypeTreeSelect.vue";
    import cardApi from "@/request/api";
    import SearchHallCardResultComponent from "@/components/phone/hall/searchHallCardResultComponent.vue";
    import ExhibitorPrinter from "@/components/shopopee/print/format/exhibitor/exhibitorPrinter.vue";

    const emits = defineEmits(['go-shop', "changeView"])
    const props = defineProps(['materialObj', "keyword", "viewList", "viewName"])

    let { proxy } = getCurrentInstance();
    const i18n = inject("i18n")

    const userInfoRef = toRef(useUserinfo())

    const keyword = ref("")
    const selectedType = ref(null)
    const materialList = ref([])
    const companyList = ref([])
    const cardList = ref([])
    const loadingFlag = ref(false)
    const currViewName = ref("material")
    const viewType = ref("block")
    const hallObj = ref({})
    const searchHolder = ref(``)

    const cols = ref(12)

    let pageNum = 1
    let pageSize = 10
    const pageObj = ref({})

    const printHallId = ref(null)

    const { phoneGoFloorCallback } = inject('threeHallFunc', { phoneGoFloorCallback: () => {} })
    const { getHallObj } = inject('threeHallFunc', { getHallObj: () => { return null } })

    function changeKeyword() {
        if (pageNum === 1){
            companyList.value = []
            materialList.value = []
            cardList.value = []
        }

        loadingFlag.value = true

        if (currViewName.value === "total" || currViewName.value === "material"){
            queryMaterialByPage(queryMaterialCallback)
        }

        if (currViewName.value === "total" || currViewName.value === "shop"){
            queryCompanyByPage(queryCompanyCallback)
        }

        if (currViewName.value === "card"){
            queryCardList()
        }
    }

    async function queryCompanyByPage(callback) {
        const request = record15Api.getRecord15ListandCompany
        const params = request.getParams()

        params.recordname = keyword.value
        params.updatedid = userInfoRef.value.hid

        request.send(params, (res) => {
            loadingFlag.value = false
            callback(res)
        })

    }

    function queryCompanyCallback(detail) {
        if (null != detail && detail.code === 200){
            // companyList.value = detail.detail
            companyList.value = companyList.value.concat(detail.detail)

            changePageObj(detail.detail)
        }else{
            companyList.value = []
        }
    }

    async function queryMaterialByPage(callback) {
        const request = materialApi.queryMaterialRecord15ModelByPage
        const params = request.getParams()

        params.updatedid = userInfoRef.value.hid
        params.productname = keyword.value
        params.bcatacode2 = selectedType.value
        params.pageNum = pageNum
        params.pageSize = pageSize

        request.send(params, (res) => {
            loadingFlag.value = false
            callback(res)
        })
    }

    function queryMaterialCallback(detail) {
        if (null != detail && detail.code === 200){
            // materialList.value = detail.detail.list
            materialList.value = materialList.value.concat(detail.detail.list)
            pageObj.value = detail.detail

            changePageObj(detail.detail)
        }else{
            materialList.value = []

        }
    }

    function queryCardList(){
        pageObj.value = {}
        cardList.value = []
        loadingFlag.value = true

        const request = cardApi.queryByHall
        const params = request.getParams()

        params.telephone = keyword.value
        params.updatedid = hallObj.value.id

        request.send(params, (res) => {
            loadingFlag.value = false

            if (res.code == 200){
                cardList.value = res.detail
            }else{
                myUtil.alertError(res.msg)
            }
        })

    }

    function goShop(obj) {
        phoneGoFloorCallback(obj.raddinfo1, obj.raddinfo2)
        emits("go-shop", obj.raddinfo1, obj.raddinfo2)
    }

    function changeView(){
        // emits("changeView", currViewName.value, keyword.value)
        selectedType.value = null
        changePage(1)

        if (currViewName.value === "card"){
            changeViewType("list")
        }

    }

    function changePage(num){
        pageNum = num
        changeKeyword()
    }

    function changePageObj(obj){
        if (null == pageObj.value.total || obj.total > pageObj.value.total || obj.pageNum != pageObj.value.pageNum){
            pageObj.value = obj
        }
    }

    function changeViewType(name){
        viewType.value = name

        if (name === "block"){
            if (myUtil.isMobile()){
                cols.value = 12
            }else{
                cols.value = 6
            }
        }else{
            cols.value = 24
        }
    }

    function scrollLoadFunc(){
        if (null != pageObj.value.hasNextPage && pageObj.value.hasNextPage === true){
            changePage(pageNum + 1)
        }
    }

    function changeProductType(){
        changePage(1)
    }

    function fillHallObj(){
        const obj = getHallObj()

        if (null != obj){
            hallObj.value = obj

            searchHolder.value = obj.addinfo6

            if (myUtil.isEmpty(obj.addinfo6) || userInfoRef.value.lang == "zh" || userInfoRef.value.lang == "szh"){
                searchHolder.value = obj.recordname
            }

            searchHolder.value = `${i18n.tkey('lang_search_text')} ${searchHolder.value} ...`

        }else{
            searchHolder.value = `${i18n.tkey('lang_search_text')}...`
        }
    }

    function clickPrint(){
        loadingFlag.value = true
        printHallId.value = hallObj.value.id
    }

    function printCallback(){
        loadingFlag.value = false
        printHallId.value = null
    }

    onBeforeMount(() => {
        if (!myUtil.isMobile()){
            cols.value = 6
        }

        fillHallObj()

    })

    onMounted(() => {
        // currViewName.value = props.viewName

        if (null != props.keyword){
            keyword.value = props.keyword
        }

        changeKeyword()
    })
</script>

<style scoped>
    ul {
        list-style: none;
        margin: 0;
        padding-left: 0;
    }

    .search-result {
        width: 100%;
        height: calc(100% - 110px);
        padding: 10px;
        overflow-x: hidden;
        overflow-y: auto;
        box-sizing: border-box;
    }

    .record-box {
        margin-bottom: 10px;
    }

    .type-toggle-box {
        text-align: right;
        box-sizing: border-box;
        padding: 0 20px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    @media screen and (max-width: 520px) {
        .search-box {
            text-align: center;
            width: 80%;
            margin: auto;
            box-sizing: border-box;
            padding: 10px;
            height: 60px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    @media screen and (min-width: 520px) {
        .search-box {
            text-align: center;
            width: 50%;
            margin: auto;
            box-sizing: border-box;
            padding: 10px;
            height: 60px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    .search-input {
        width: calc(100% - 110px);
    }

    .printer-dom {
        position: fixed;
        top: 200vh;
        left: 0;
    }
</style>